import { create } from 'zustand';

export type ExternalPartiesScanStore = {
  /** Participants with a full external parties scan running; kept outside components as a scan outlives its view. */
  scanning: Record<string, boolean>;
  setScanning: (participantName: string, scanning: boolean) => void;
};

export const useExternalPartiesScanStore = create<ExternalPartiesScanStore>((set) => ({
  scanning: {},
  setScanning: (participantName, scanning) =>
    set((state) => ({ scanning: { ...state.scanning, [participantName]: scanning } })),
}));
